/*
 # Modal Close Others

 This co-controller is applied to an accordion and has the effect
 of closing other accordions when opened.

 The other accordions that will be closed are specified with a data
 attribute of:

 data-accordion-close-group="accordion-a accordion-b"

 the value of this attribute is consumed in relationship to
 other accordion instances which have the same attribute,
 on a space-delimited basis.

*/

import {
  assignController, getControllers, controllersAvailable,
  selectAll, setClassState, unsetClassState, selectAlso,
} from '../api/element-manipulation'

assignController('accordionHeader', (element) => {
  const headerElement = selectAll(document, '[data-hook~="header"]')[0]

  const handleOpened = () => {
    selectAlso(headerElement, '[data-class-menu-open]').forEach((stateElement) => {
      unsetClassState(stateElement, stateElement.dataset.classMenuClosed)
      setClassState(stateElement, stateElement.dataset.classMenuOpen)
    })
    headerElement.dataset.noOffset = '1'
    setTimeout(() => {
      controller.header.resize()
      window.scrollTo(0, 0)
    }, 100)
  }

  const handleClosed = () => {
    selectAlso(headerElement, '[data-class-menu-open]').forEach((stateElement) => {
      unsetClassState(stateElement, stateElement.dataset.classMenuOpen)
      setClassState(stateElement, stateElement.dataset.classMenuClosed)
    })
    headerElement.dataset.noOffset = '0'
    setTimeout(() => {
      controller.header.resize()
    }, 100)
  }

  controllersAvailable(() => {
    if (!headerElement) {
      return
    }
    // controller.header = getControllers(headerElement).header
    controller.accordion = getControllers(element).accordion
    if (!controller.accordion || !controller.header) {
      return
    }
    controller.accordion.opened.push(handleOpened)
    controller.accordion.closed.push(handleClosed)
  })

  const controller = {
    headerElement,
    element,
  }

  return controller
})
